import { MarkedByEnum, ScriptTypeEnum } from '@doltech/utils/lib/constants';
import { get } from 'lodash';
import { types as t } from 'mobx-state-tree';

import { ConversationScript } from '../../Script/_implementations/conversation-script.store';
import { MonologScript } from '../../Script/_implementations/monolog-script.store';
import { AbstractTestSection } from '../abstract-test-section.store';

export const ListeningTestSection = AbstractTestSection.named('ListeningTestSection')
  .props({
    testTakenTime: t.maybeNull(t.number),
    sectionType: t.maybeNull(t.string),
    script: t.maybeNull(
      t.union(
        {
          dispatcher: (s) => {
            if (s) {
              switch (s.type) {
                case ScriptTypeEnum.MONOLOG:
                  return MonologScript;
                case ScriptTypeEnum.CONVERSATION:
                  return ConversationScript;
                default:
                  throw new Error(`Can't resolve passage type ${s.type}`);
              }
            }
            return MonologScript;
          },
        },
        MonologScript,
        ConversationScript
      )
    ),
  })
  .views((self) => ({
    getMarkedBy() {
      if (get(self, 'passage.markedBy')) {
        return get(self, 'passage.markedBy');
      }
      return MarkedByEnum.ALPHABET;
    },
  }));
